export default __webpack_public_path__ + "static/media/loading.3ea88c85.gif";